declare global {
    interface Window {
        dataLayer: any;
    }
}

interface EventData {
    event: string,
    ecommerce?: EcommerceData,
    [key: string]: any
}

interface EcommerceData {
    currency: string;
    value: number;
    transaction_id?: string;
    shipping?: number;
    items: Item[];
}

interface Item {
    item_id: string;
    item_name: string;
    item_category: string;
    price: number;
    quantity: number;
}

export function pushGaEvent(eventData: EventData) {
    let dataLayer = window.dataLayer || [];
    try {
        dataLayer.push(eventData);
    } catch (error) {
        console.log(error);
    }
}
